import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "step2-container"
};
import { reactive, watch, ref } from "vue";
import InformationForm from "@/components/information-form.vue";
export default {
  __name: 'step-2',
  props: {
    rules: {
      type: Object,
      required: true
    }
  },
  emits: ["update:form", "update:form-blur"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const informationFormRef = ref(null);
    const form = reactive({
      firstName: "",
      lastName: "",
      email: "",
      phone: ""
    });
    const handleFormUpdate = val => {
      Object.assign(form, val);
      emit("update:form", form);
    };
    const handleFormBlur = () => {
      emit("update:form-blur");
    };
    const validate = () => {
      return informationFormRef.value?.validate();
    };
    // Expose validation method to parent component
    __expose({
      validate
    });

    // Listen for form changes to ensure data synchronization
    watch(form, () => {
      emit("update:form", form);
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createStaticVNode("<div class=\"step2-title\" data-v-099786e6>Step <span data-v-099786e6>2</span>:</div><div class=\"step2-subtitle\" data-v-099786e6>Create your account</div><div class=\"step2-desc\" data-v-099786e6><span class=\"desc-light1\" data-v-099786e6> Make sure your email is <span class=\"desc-bold\" data-v-099786e6>typed correctly.</span></span><span data-v-099786e6> Your password will be sent there. If your email is an existing account, the membership will be automatically applied to that account. </span></div>", 3)), _createVNode(InformationForm, {
        ref_key: "informationFormRef",
        ref: informationFormRef,
        form: form,
        rules: __props.rules,
        "onUpdate:form": handleFormUpdate,
        "onUpdate:formBlur": handleFormBlur
      }, null, 8, ["form", "rules"])]);
    };
  }
};